import React from 'react';
// import * as pt from 'prop-types';
// import createReactClass from 'create-react-class';
import struct from 'observ-struct';
import ObservApi from '../../lib/observable-api';
import Store from '../../vast/listings/Store';
import VastListing from '../../vast/VastListing';

export default function VastListRoute (api, socket, opts, match) {
    var VastApi = ObservApi(api.vast);
    var VastStore = Store(VastApi.bus);

    var state = struct({
        campaigns: VastStore.state
    });

    var actions = VastApi.actions;

    return function VastListRoute (props) {
        return <VastListing
            {...props}
            store={state}
            actions={actions}
        />;
    };
};
